<template>
<e-chart
  ref="chart"
  :show-back-btn="showBackBtn"
  @initialized="onChartReady"
  @destroy="onChartDestroy"
  @back="onBackBtnClick"
/>
</template>

<script>
import BaseFactorChart from './BaseFactorChart'
import EChart from '../../Charts/ECharts'

const ROOT_VOCS_ID = 'rootVOCs'

export default {
  name: 'VOCsChart',
  components: {EChart},
  extends: BaseFactorChart,
  data () {
    return {
      parentGroupId: ROOT_VOCS_ID
    }
  },
  computed: {
    showBackBtn () {
      return this.parentGroupId !== ROOT_VOCS_ID
    }
  },
  methods: {
    setSeries (chartOpt) {
      let {factorGroup} = this
      this.buildFormatFactorGroup(factorGroup, this.data)
      this.buildSeries(chartOpt)
    },
    buildFormatFactorGroup (factorGroup, data) {
      let dataLen = data.length
      let parents = []
      let factors = []
      let vocGroup = JSON.parse(JSON.stringify(factorGroup))
      let factorGroups = [vocGroup]
      let factorGroupMap = this.factorGroupMap = {}
      let {unitProp} = this

      for (let i = 0; i < factorGroups.length; i++) {
        let factorGroup = factorGroups[i]
        let {children} = factorGroup

        if (children) {
          factorGroups.push(...children)
          factorGroupMap[factorGroup.id] = factorGroup
          parents.push(factorGroup)
          factorGroup.values = new Array(dataLen).fill(NaN)
        } else {
          factors.push(factorGroup)
          factorGroup.values = []
          this.unit = factorGroup[unitProp]
        }
      }

      parents.reverse()

      factors.forEach(({id, parentId, values}) => {
        let factorGroup = factorGroupMap[parentId]
        let factorGroupValues = factorGroup.values

        data.forEach((data, index) => {
          let value = data[id]

          if (Number.isFinite(value)) {
            values.push(value)

            if (Number.isNaN(factorGroupValues[index])) {
              factorGroupValues[index] = 0
            }

            factorGroupValues[index] += value
          } else {
            values.push(NaN)
          }
        })
      })

      parents.forEach(({parentId, values}) => {
        let parent = factorGroupMap[parentId]

        if (!parent) {
          return
        }

        let parentValues = parent.values

        values.forEach((value, index) => {
          if (Number.isFinite(value)) {
            if (Number.isNaN(parentValues[index])) {
              parentValues[index] = 0
            }

            parentValues[index] += value
          }
        })
      })

      parents.forEach(({values}) => {
        values.forEach((value, index, values) => {
          values[index] = Number.isFinite(value) ? Number(value.toFixed(3)) : NaN
        })
      })

      vocGroup.parentId = ROOT_VOCS_ID
      factorGroupMap[ROOT_VOCS_ID] = {
        id: 'VOCs',
        name: 'VOCs总量',
        children: [vocGroup]
      }
    },
    buildSeries (chartOpt) {
      let {factorGroupMap} = this
      let factorGroup = factorGroupMap[this.parentGroupId]

      chartOpt.title.text = factorGroup.name
      chartOpt.yAxis[0].name = this.unit
      chartOpt.series = factorGroup.children.map(factor => ({
        id: factor.id,
        name: factor.name,
        type: 'line',
        data: factor.values,
        symbolSize: 16,
        itemStyle: {
          opacity: 0
        },
        emphasis: {
          itemStyle: {
            opacity: 1
          }
        }
      }))
    },
    reRender () {
      let chartOpt = this.getChart().getOpt()
      let factorGroup = this.factorGroupMap[this.parentGroupId]

      chartOpt.title[0].text = factorGroup.name
      chartOpt.legend[0].selected = {}
      this.buildSeries(chartOpt)
      this.getChart().setOpt(chartOpt)
    },
    onChartClick (param) {
      let factorId = param.seriesId

      if (!this.factorGroupMap[factorId]) {
        return
      }

      this.parentGroupId = factorId
      this.reRender()
    },
    onBackBtnClick () {
      let factorGroup = this.factorGroupMap[this.parentGroupId]
      this.parentGroupId = factorGroup.parentId
      this.reRender()
    },
    onChartReady (chart) {
      chart.on('click', this.onChartClick)
    },
    onChartDestroy (chart) {
      chart.off('click', this.onChartClick)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/FactorCharts/VOCsChart.vue